/**
 * url获取参数
 * 说明：兼容hash路由参数，针对单页面路由，存在将参数设置在hash路由的情况
 */

import url from '@common/url'

// 从hash路由获取参数值
const getUrlHashKeyValue = (key) => {
  const values = url('?', `https://www.feidee.com?${window.location.hash.split('?')[1] || ''}`)
  return values ? values[key] : ''
}

export default (key) => {
  const urlKeyValue = url(`?${key}`)
  return urlKeyValue || getUrlHashKeyValue(key)
}



// WEBPACK FOOTER //
// ./node_modules/@common/collect/src/lib/url.js